<template>
    <side-panel @close="handleClose" @afterEnter="initToken">
        <template #header>
            <h3 class="mt-0 clearfix">
                {{ $l10n.__('Ajouter une carte') }}
            </h3>
        </template>
        <template #content class="prelative">
            <div id="modalStripe" v-loading="stripeLoading" class="p-4">
                <form id="payment-form" :action="formAction" method="post">
                    <h2 class="mb-3 mt-0 semibold"></h2>
                    <p id="directDebitAlert" class="mb-3"></p>
                    <div class="form-group mb-3">
                        <label class="form-label label-block">{{ $l10n.__('Email') }}</label>
                        <input
                            v-model="stripeEmail"
                            name="stripeEmail"
                            class="span_12 h-4"
                            type="email"
                            placeholder="janedoe@gmail.com"
                            required=""
                        />
                    </div>
                    <h3 class="semibold my-3">{{ $l10n.__('Vos informations de paiement') }}</h3>
                    <div style="height: 50px" class="mt-4">
                        <el-form
                            ref="stripeForm"
                            labelPosition="top"
                            :inline="false"
                            :inlineMessage="true"
                            :model="stripeForm"
                        >
                            <el-form-item prop="creditcard">
                                <div ref="creditcard">
                                    <!-- A Stripe Element will be inserted here. -->
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>

                    <span v-if="errors.get('card-number')" class="red error">{{ errors.get('card-number') }}<br/></span>
                    <span v-if="errors.get('card-expiry')" class="red error">{{ errors.get('card-expiry') }}<br/></span>
                    <span v-if="errors.get('card-cvc')" class="red error">{{ errors.get('card-cvc') }}<br/></span>

                    <p id="powered-stripe" class="semibold aright">
                        <i class="fa fa-lock"> </i>
                        {{ $l10n.__('Stripe') }}
                    </p>
                </form>
            </div>
        </template>

        <template v-if="!stripeLoading" #footer>
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click.prevent="handleClose"
            />
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="submitForm" />
        </template>
    </side-panel>
</template>

<script>
import SidePanel from 'vcomponents/utilities/SidePanel.vue';
import FormMixins from '../../mixins/FormMixins';
import StripeMixins from '../../mixins/StripeMixins';
export default {
    components: {
        SidePanel,
    },
    mixins: [StripeMixins, FormMixins],
    props: {
        thirdid: {
            type: Number,
            required: true,
        },
    },
    emits: ['close', 'save-card'],
    data() {
        return {
            formAction: '/stripe/card/save',
            stripeForm: {},
            loadedInMixin: false,
        };
    },
    created() {},
    methods: {
        handleClose() {
            this.$emit('close');
        },
        stripeInitElements() {
            this.stripeElement = this.stripeResources.lib
                .elements()
                .create('card', { hidePostalCode: true });
            this.stripeElement.mount(this.$refs.creditcard);
        },

        submitForm() {
            this.stripeLoading = true;
            this.stripeResources.lib
                .handleCardSetup(this.clientSecret, this.stripeElement, {
                    payment_method_data: {
                        billing_details: { email: this.stripeEmail },
                    },
                })
                .then((result) => {
                    if (result.setupIntent.status == 'succeeded') {
                        this.$emit('save-card', result);
                    } else {
                        Push.error(
                            this.$l10n.__(
                                "Une erreur est survenue lors de l'enregistrement de votre carte.",
                            ),
                            false,
                        );
                        this.stripeLoading = false;
                    }
                })
                .catch((error) => {
                    Push.error(
                        this.$l10n.__(
                            "Une erreur est survenue lors de l'enregistrement de votre carte.",
                        ),
                        false,
                    );
                    this.stripeLoading = false;
                });
        },
    },
};
</script>
